import type {
  ActionResult,
  CarrierCoverageResponse,
  CarrierDefaultsResponse,
  CarrierRule,
  CarrierRuleInput,
  CarrierRuleListResponse,
  CarrierSimulationBody,
  CarrierSimulationResult,
} from '@flux/shared';
import { apiFetch } from '@/lib/api/client.js';

/**
 * Couche réseau de l'écran Transporteurs (`02` §9), refondu le 10/09/2026.
 *
 * La liste de règles est **globale** : plus de paramètre `store` sur le CRUD,
 * seule la matrice de couverture en prend un (elle interroge les profils
 * d'expédition d'une boutique Shopify). Les clés de requête vivent dans
 * `src/lib/query/keys.ts`.
 */
export function fetchCarrierRules(): Promise<CarrierRuleListResponse> {
  return apiFetch<CarrierRuleListResponse>('/api/carriers/rules');
}

export function createCarrierRule(body: CarrierRuleInput): Promise<CarrierRule> {
  return apiFetch<CarrierRule>('/api/carriers/rules', { method: 'POST', body });
}

export function updateCarrierRule(id: string, body: CarrierRuleInput): Promise<CarrierRule> {
  return apiFetch<CarrierRule>(`/api/carriers/rules/${id}`, { method: 'PUT', body });
}

export function deleteCarrierRule(id: string): Promise<ActionResult> {
  return apiFetch<ActionResult>(`/api/carriers/rules/${id}`, { method: 'DELETE' });
}

export function duplicateCarrierRule(id: string): Promise<CarrierRule> {
  return apiFetch<CarrierRule>(`/api/carriers/rules/${id}/duplicate`, { method: 'POST' });
}

/** La liste doit être **complète** : le serveur refuse un ordre partiel (400). */
export function reorderCarrierRules(ruleIds: string[]): Promise<CarrierRuleListResponse> {
  return apiFetch<CarrierRuleListResponse>('/api/carriers/rules/reorder', {
    method: 'POST',
    body: { ruleIds },
  });
}

export function simulateCarrier(body: CarrierSimulationBody): Promise<CarrierSimulationResult> {
  return apiFetch<CarrierSimulationResult>('/api/carriers/simulate', { method: 'POST', body });
}

export function fetchCarrierCoverage(store: string): Promise<CarrierCoverageResponse> {
  return apiFetch<CarrierCoverageResponse>('/api/carriers/coverage', { query: { store } });
}

export function fetchCarrierDefaults(): Promise<CarrierDefaultsResponse> {
  return apiFetch<CarrierDefaultsResponse>('/api/carriers/defaults');
}
